import SolutionFeaturesI18n from "@/components/landing/shared/SolutionFeaturesI18n";
import { Clock, MessageCircle, ArrowRightLeft, Inbox, BarChart3 } from "lucide-react";
const KundenserviceFeaturesSection = () => <SolutionFeaturesI18n translationPrefix="kundenserviceSolution" icons={[Clock, MessageCircle, ArrowRightLeft, Inbox, BarChart3]} />;
export default KundenserviceFeaturesSection;
